<div class="p-d-flex p-flex-column p-ai-center p-jc-center gap-6 text-center">
  <div style="text-align: center;">
    Na vaš nalog se upravo prijavio neko drugi. Možete preuzeti sesiju (drugi
    korisnik će biti odjavljen) ili se odjaviti.
  </div>
  <div style="text-align: center;">
    Ukoliko u vašoj kompaniji postoji više korisnika, možete im otvoriti novi
    korisnički nalog.

    <a href="https://ekompanija.tawk.help/article/kako-da-dodam-novog-korisnika"
      >Pogledajte kako.</a
    >
  </div>
  <button
    pButton
    pRipple
    type="button"
    label="Preuzmi sesiju"
    icon="pi pi-sign-in"
    class="p-button-outlined"
    [loading]="preuzimanjeUToku"
    [disabled]="preuzimanjeUToku"
    (click)="preuzmiSesiju()"
  ></button>
  <div>Automatska odjava za {{ remainingTime }}s</div>
</div>
